<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Configurações diretórios espelho</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow">
                            <div class="card-header mt-3">
                                <span v-for="(hierarchy, index) in hierarchy_directories" :key="index"><button
                                        class="btn btn-link"
                                        @click="beforeDirectory(hierarchy.from != null ? hierarchy.from.id : null)"><i
                                            class="fa fa-arrow-left"></i> Voltar</button> | <strong>Diretório
                                        atual:</strong> <span v-for="(item, index) in sequence_directories"
                                        :key="index">
                                        {{ item }} </span></span>

                                <div class="dropdown float-right mb-4">
                                    <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-plus"> </i> Novo
                                    </button>
                                    <div class="dropdown-menu animated--fade-in" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item" @click="showModalNewDirectory()"><i
                                                class="fa fa-folder"></i> Diretório</button>
                                    </div>
                                </div>                               
                                <div class="dropdown float-right mb-4 mr-4">
                                    <button class="btn btn-secondary" type="button" @click="changeViewingMode()">
                                        <i class="fa fa-eye"> </i> Modo {{ viewing_mode == 'list' ? 'grade' : 'lista' }}
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <div v-if="viewing_mode == 'card'">
                                    <div class="row" v-if="directories.length <= 0">
                                        <div class="col-sm-12 col-xs-12 col-lg-12">
                                            <div class="alert alert-danger">
                                                Ops...Diretório vazio =/
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="!filter_send_by_client">
                                        <div class="col-md-3 col-lg-3 col-sm-12 mb-3" v-for="(directory) in directories"
                                            :key="directory.id">
                                            <div class="card shadow border-left-danger">
                                                <!-- Card Header - Dropdown -->
                                                <div
                                                    class="card-header d-flex flex-row align-items-center justify-content-between">
                                                    <h6 class="m-0 font-weight-bold text-primary">Diretório
                                                    </h6>
                                                    <div class="dropdown no-arrow">
                                                        <a class="dropdown-toggle" href="#" role="button"
                                                            id="dropdownMenuLink" data-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                                        </a>
                                                        <div class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                                                            aria-labelledby="dropdownMenuLink">
                                                            <div class="dropdown-header">Ações:</div>
                                                            <a class="dropdown-item" href="#"
                                                                @click="editDirectory(directory.id)">Editar</a>
                                                            <div class="dropdown-divider"></div>
                                                            <a class="dropdown-item" href="#"
                                                                @click="removeDirectory(directory.id)">Remover</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Card Body -->
                                                <div class="card-body pointer m-0"
                                                    @click="enterDirectory(directory.uuid_to, directory.to.name)">
                                                    <p><i class="fa fa-folder fa-3x mr-3 m-0"></i> <button
                                                            class="btn btn-link">{{ directory.to.name }}</button></p>
                                                </div>
                                                <div class="card-footer m-0">
                                                    <p class="text-left"><small>Criado em: {{ directory.to.created_at
                                                            }}</small> <small
                                                            class="ml-5"><strong>Subdiretórios:</strong> {{
                                                            directory.to.totalSubdirectories }}</small> </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="viewing_mode == 'list'">
                                    <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Nome</th>
                                                    <th class="text-center">Criado em</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="!filter_send_by_client">
                                                <tr class="pointer" v-for="(directory, index) in directories"
                                                    :key="index.id">
                                                    <td @click="enterDirectory(directory.uuid_to, directory.to.name)">{{
                                                        index + 1 }}</td>
                                                    <td @click="enterDirectory(directory.uuid_to, directory.to.name)"><i
                                                            class="fa fa-folder directory"></i> {{ directory.to.name }}
                                                    </td>
                                                    <td class="text-center"
                                                        @click="enterDirectory(directory.uuid_to, directory.to.name)">{{
                                                            directory.to.created_at }} </td>
                                                    <td>
                                                        <div class="dropdown">
                                                            <button class="btn btn-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                Ações
                                                            </button>
                                                            <div class="dropdown-menu animated--fade-in"
                                                                aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item" href="#"
                                                                    @click="editDirectory(directory.id)">Editar</a>
                                                                <a class="dropdown-item" href="#"
                                                                    @click="removeDirectory(directory.id)">Remover</a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-show="directories.length <= 0">
                                                    <td colspan="6" class="text-center">Nenhum registro encontrado</td>
                                                </tr>
                                            </tbody>
                                            <tbody>
                                                <tr class="pointer" v-for="(file, index) in files" :key="index.id">
                                                    <td>{{ index + 1 }}</td>
                                                    <td @click="downloadFile(file.id)"><i class="fa fa-file file"></i>
                                                        {{ file.description }}
                                                        <div v-if="file.request_confirmation">
                                                            <span class="badge badge-success"
                                                                v-if="file.confirmation"><i class="fa fa-check"></i>
                                                                Confirmado</span>
                                                            <span class="badge badge-warning"
                                                                v-if="!file.confirmation"><i
                                                                    class="fa fa-hourglass"></i> Confirmação
                                                                Pendente</span>
                                                        </div>

                                                    </td>
                                                    <td class="text-center">{{ file.overdue ? file.overdue_formatted :
                                                        '-'
                                                        }}
                                                        <div v-if="file.request_confirmation && !file.confirmation">
                                                            <span class="badge badge-danger" v-if="file.is_expired"><i
                                                                    class="fa fa-exclamation"></i> Vencido</span>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">{{ file.number_download }} </td>
                                                    <td class="text-center">{{ file.created_at }} </td>
                                                    <td>
                                                        <div class="dropdown">
                                                            <button class="btn btn-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                Ações
                                                            </button>
                                                            <div class="dropdown-menu animated--fade-in"
                                                                aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item" href="#"
                                                                    @click="downloadFile(file.id)">Baixar aquivo</a>
                                                                <a class="dropdown-item" href="#"
                                                                    @click="editFile(file.id)">Editar</a>
                                                                <a class="dropdown-item" href="#"
                                                                    @click="removeFile(file.id)">Remover</a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->

    <div id="modalDisplayNewDirectory" class="modal" :style="{ display: modalDisplayNewDirectory }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewDirectory">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newDirectoryLabel">Novo diretório</h5>
                            <button type="button" class="close" @click="closeModalNewDirectory()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição</label>
                                    <input type="text" class="form-control" placeholder="Ex: Financeiro"
                                        v-model="directory.name">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalNewDirectory()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory" :disabled='!isDisabledDirectory'><i
                                    class="fa fa-save"></i>
                                Cadastrar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayEditDirectory" class="modal" :style="{ display: modalDisplayEditDirectory }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateDirectory">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newDirectoryLabel">Atualizar diretório</h5>
                            <button type="button" class="close" @click="closeModalEditDirectory()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição</label>
                                    <input type="text" class="form-control" placeholder="Ex: Financeiro"
                                        v-model="directory.name">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalEditDirectory()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory" :disabled='!isDisabledDirectory'><i
                                    class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            viewing_mode: 'list',
            directories: {},
            hierarchy_directories: {},
            sequence_directories: [],
            modalDisplayNewDirectory: 'none',
            modalDisplayEditDirectory: 'none',
            from: null,
            directory_before: null,
            enable_error_list: false,
            errors: [],
            directory: {
                name: '',
                from: null,
                to:null,
                directory_id: ''
            }
        }
    },

    computed: {
        isDisabledDirectory: function () {
            return this.directory.name != '';
        },
    },
    mounted() {
        this.isLoading = false;
        this.getDirectories();

    },

    methods: {
        onCancel() { },

        changeViewingMode() {
            if (this.viewing_mode == 'list') {
                this.viewing_mode = 'card';
            } else {
                this.viewing_mode = 'list';
            }
        },

        beforeDirectory(before) {
            this.sequence_directories.pop();
            this.to = before;
            this.getDirectories();
        },

         enterDirectory(next, name = '') {
            this.to = next;
            this.sequence_directories.push(name + " /  ");
            this.getDirectories();
        },


        getDirectories() {
            this.isLoading = true;
            api.get('/setting/mirrorDirectory', {
                params: {
                    'from': this.to,
                    'to': this.to
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.directories = response.data.directories;
                     this.hierarchy_directories = response.data.hierarchyDirectories;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        createNewDirectory(event) {
            event.preventDefault();
            this.directory.from = this.to;
            this.isLoading = true;
            api.post('/setting/createMirrorDirectory', this.directory)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Diretório cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.closeModalNewDirectory();
                    this.directory = {};
                    this.getDirectories();
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalNewDirectory();
                    if (error.status == 422) {
                        this.$notify({
                            title: "Falha",
                            text: "Diretório já existente neste nível!",
                            type: 'error'
                        });
                    } else {
                        handleRequestErrors(error.status, error);
                    }
                })
        },

        editDirectory(directory_id) {
            this.directories.forEach(directory => {
                if (directory.id == directory_id) {
                    this.directory.directory_id = directory_id;
                    this.directory.name = directory.to.name;
                    this.showModalEditDirectory();
                }
            });
        },

        updateDirectory(event) {
            event.preventDefault();
            this.directory.from = this.to;
            this.isLoading = true;
            api.put('/setting/' + this.directory.directory_id + '/updateMirrorDirectory', this.directory)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Diretório atualizado com sucesso!",
                        type: 'success'
                    });
                    this.closeModalEditDirectory();
                    this.directory = {};
                    this.getDirectories();
                    this.directory.name = '';

                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalEditDirectory();
                    if (error.status == 422) {
                        this.$notify({
                            title: "Falha",
                            text: "Diretório já existente neste nível!",
                            type: 'error'
                        });
                    } else {
                        handleRequestErrors(error.status, error);
                    }

                })
        },


        removeDirectory(directory_id) {
            this.$confirm(
                {
                    message: 'Deseja remover o diretório?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/setting/' + directory_id + "/removeMirrorDirectory")
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Diretório excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.getDirectories();

                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        showModalNewDirectory() {
            this.modalDisplayNewDirectory = 'block';
        },
        closeModalNewDirectory() {
            this.modalDisplayNewDirectory = 'none'; 
            this.directory.name = '';
        },
        showModalEditDirectory() {
            this.modalDisplayEditDirectory = 'block';
        },
        closeModalEditDirectory() {
            this.modalDisplayEditDirectory = 'none';
            this.directory.name = '';
        }
    }
}
</script>

<style>
.pointer {
    cursor: pointer;
}

.modal {
    position: fixed;
    z-index: 1999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #f5f5f5;
    margin: 3% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 65%;
}

.modal-header {
    color: #000;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.directory {
    color: #a70000;
}

.file {
    color: #000fe6;
}

@media (max-width: 576px) {
    .modal-content {
        width: 90% !important;
    }
}
</style>